var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarketCalendar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.626 22.853",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054",
    transform: "matrix(1, 0, 0, 1, -1037.848999, -427.34201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M.44-7.986v1.067H4.51L1.419,0H2.684L5.742-7.051v-.935Z",
    transform: "translate(1046.662 446.045)",
    fill: "#5c3bd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "np_calendar_4610795_000000",
    d: "M28.194,9.265a2.316,2.316,0,0,0-1.647-.685H22.662V7.028H21.1v1.56H18V7.028h-1.56v1.56h-3.1V7.028h-1.56v1.56H7.887A2.333,2.333,0,0,0,5.554,10.92V27.248a2.316,2.316,0,0,0,.686,1.647,2.346,2.346,0,0,0,1.647.686h18.66a2.334,2.334,0,0,0,2.333-2.333V10.92a2.347,2.347,0,0,0-.686-1.654ZM7.107,10.92a.78.78,0,0,1,.78-.779h3.885v1.552h1.553V10.141h3.112v1.552H17.99V10.141H21.1v1.552h1.553V10.141h3.892a.78.78,0,0,1,.78.779v3.112H7.107ZM27.32,27.248a.78.78,0,0,1-.78.78H7.887a.78.78,0,0,1-.78-.78V15.585h20.22Z",
    transform: "translate(1032.445 420.465)",
    fill: "#5d3cda",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/market-calendar.b209dd47.svg";
export { ForwardRef as ReactComponent };